import {Chip} from "@mui/material";
import ChairIcon from '@mui/icons-material/Chair';
import React from "react";

import '../../css/App.css';

const NUMBER_OF_SEATS_TO_HIDE_OCCUPANCY_CHIP = 1;

export default function SeatDetail({ session, compactView = true }) {

    const shouldShowSeatDetails = session.bookingsCount !== NUMBER_OF_SEATS_TO_HIDE_OCCUPANCY_CHIP || session.seatsCount !== NUMBER_OF_SEATS_TO_HIDE_OCCUPANCY_CHIP;

    if (shouldShowSeatDetails) {
        return (
            <Chip
                size="small"
                icon={compactView ? <ChairIcon /> : null}
                label={`${session.bookingsCount}/${session.seatsCount}`}
                sx={{ margin: '0.125rem', backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
            />
        );
    }
}
